import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

// Layout
import Layout from './components/Layout';

// Sider
import Home from './pages/Home';
import Industri from './pages/Industri';
import Marine from './pages/Marine';
import Kraftvaerker from './pages/Kraftvaerker';
import Fjernvarme from './pages/Fjernvarme';
import TurbineIsolering from './pages/TurbineIsolering';
import Cases from './pages/Cases';
import News from './pages/News';
import About from './pages/About';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import { NotFoundPage, ForbiddenPage } from './pages/ErrorPages';

export default function App() {
  return (
    <HelmetProvider>
      <Routes>
        {/* DANSKE RUTER */}
        <Route path="/" element={<Layout><Home isEn={false} /></Layout>} />
        <Route path="/industri" element={<Layout><Industri isEn={false} /></Layout>} />
        <Route path="/marine" element={<Layout><Marine isEn={false} /></Layout>} />
        <Route path="/kraftvaerker" element={<Layout><Kraftvaerker isEn={false} /></Layout>} />
        <Route path="/fjernvarme" element={<Layout><Fjernvarme isEn={false} /></Layout>} />
        <Route path="/turbine-isolering" element={<Layout><TurbineIsolering isEn={false} /></Layout>} />
        <Route path="/cases" element={<Layout><Cases isEn={false} /></Layout>} />
        <Route path="/cases/:slug" element={<Layout><Cases isEn={false} /></Layout>} />
        <Route path="/nyheder" element={<Layout><News isEn={false} /></Layout>} />
        <Route path="/nyheder/:slug" element={<Layout><News isEn={false} /></Layout>} />
        <Route path="/om" element={<Layout><About isEn={false} /></Layout>} />
        <Route path="/kontakt" element={<Layout><Contact isEn={false} /></Layout>} />
        <Route path="/privatlivspolitik" element={<Layout><Privacy isEn={false} /></Layout>} />

        {/* ENGELSKE RUTER */}
        <Route path="/en" element={<Layout><Home isEn={true} /></Layout>} />
        <Route path="/en/industry" element={<Layout><Industri isEn={true} /></Layout>} />
        <Route path="/en/marine" element={<Layout><Marine isEn={true} /></Layout>} />
        <Route path="/en/power-plants" element={<Layout><Kraftvaerker isEn={true} /></Layout>} />
        <Route path="/en/district-heating" element={<Layout><Fjernvarme isEn={true} /></Layout>} />
        <Route path="/en/turbine-insulation" element={<Layout><TurbineIsolering isEn={true} /></Layout>} />
        <Route path="/en/cases" element={<Layout><Cases isEn={true} /></Layout>} />
        <Route path="/en/cases/:slug" element={<Layout><Cases isEn={true} /></Layout>} />
        <Route path="/en/news" element={<Layout><News isEn={true} /></Layout>} />
        <Route path="/en/news/:slug" element={<Layout><News isEn={true} /></Layout>} />
        <Route path="/en/about" element={<Layout><About isEn={true} /></Layout>} />
        <Route path="/en/contact" element={<Layout><Contact isEn={true} /></Layout>} />
        <Route path="/en/privacy-policy" element={<Layout><Privacy isEn={true} /></Layout>} />

        {/* FEJLSIDER */}
        <Route path="/404" element={<Layout><NotFoundPage isEn={false} /></Layout>} />
        <Route path="/en/404" element={<Layout><NotFoundPage isEn={true} /></Layout>} />
        <Route path="/403" element={<Layout><ForbiddenPage isEn={false} /></Layout>} />
        <Route path="/en/403" element={<Layout><ForbiddenPage isEn={true} /></Layout>} />

        {/* CATCH-ALL (404) */}
        <Route path="*" element={<Layout><NotFoundPage isEn={false} /></Layout>} />
      </Routes>
    </HelmetProvider>
  );
}
